export default __webpack_public_path__ + "static/media/Tick.16e1fe67.svg";